<mat-expansion-panel
  *ngIf="!!user"
  class="user-panel"
  [expanded]="isPanelExpanded"
  (opened)="toggleExpanded(true)"
  (closed)="toggleExpanded(false); closeEditView()"
  hideToggle="true"
  [id]="user.id"
>
  <mat-expansion-panel-header class="user-header">
    <mat-panel-title>
      <div class="user-info-container">
        <h4>
          {{ user.name | titlecase }}
        </h4>
        <span *ngIf="isUserDeactivated" class="status-chip deactivated">
          Deactivated
        </span>
      </div>
      <ng-container *ngIf="!isEditing; else cancel">
        <emperor-button
          *ngIf="canEdit"
          [uiButtonType]="EmperorUIButtonTypes.Text"
          (click)="edit()"
        >
          <span class="button-text">Edit</span>
        </emperor-button>
        <emperor-icon
          class="expansion-icon"
          name="keyboard_arrow_down"
          [class.open]="isPanelExpanded"
        ></emperor-icon>
      </ng-container>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <mat-expansion-panel-body>
    <app-add-user-form
      [existingUser]="user"
      [isReadonly]="!isEditing"
      [isFTW]="true"
      [submitButtonText]="isUserDeactivated ? 'Reactivate user' : 'Update user'"
      (submitClick)="updateUser($event)"
    ></app-add-user-form>
  </mat-expansion-panel-body>
</mat-expansion-panel>

<!-- TEMPLATES -->
<ng-template #cancel>
  <emperor-button
    [uiButtonType]="EmperorUIButtonTypes.Text"
    (click)="closeEditView()"
  >
    <emperor-icon class="close-icon" name="close"></emperor-icon>
  </emperor-button>
</ng-template>
